module.exports = __webpack_public_path__ + "img/logo-white.8e3163fe.png";